module.exports = __webpack_public_path__ + "static/media/javascript.2d2e31cc.svg";